import { render, staticRenderFns } from "./BlockPlaceholder.vue?vue&type=template&id=201ba022&scoped=true&"
import script from "./BlockPlaceholder.vue?vue&type=script&lang=js&"
export * from "./BlockPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./BlockPlaceholder.vue?vue&type=style&index=0&id=201ba022&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201ba022",
  null
  
)

export default component.exports